<template>
  <div>
    <p class="title">Selected videos</p>
    <v-data-table :headers="columns[$country]" :items="selectedVideos" :rows-per-page-items="[100]"
      :pagination.sync="pagination" :total-items="selectedVideos.length - 1">
      <template slot="items" slot-scope="{ item, index }" v-if="index !== 0">
        <td>{{ item.club }}</td>
        <td v-if="$country === 'US'">{{ item.team }}</td>
        <td>{{ item.region }}</td>
        <td>{{ item.district }}</td>
        <td>{{ item.competition }}</td>
        <td>{{ item.username }}</td>
        <td>{{ item.comment }}</td>
        <td>{{ item.video }}</td>
        <td>
          <v-checkbox :value="item.bookmarked" @change="toggleBookmark(index)"></v-checkbox>
        </td>
        <td class="actions">
          <v-icon class="mr-2 cream-delete-button" title="Delete" @click="removeVideo(index)">mdi-delete</v-icon>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" @click.native="exportCSV">Export CSV</v-btn>
  </div>
</template>

<script>
export default {
  name: 'CreamModeSelection',
  props: ['selectedVideos'],
  data () {
    return {
      columns: {
        FR: [
          {
            text: 'Club',
            value: 'club'
          },
          {
            text: 'Region',
            value: 'region'
          },
          {
            text: 'District',
            value: 'district'
          },
          {
            text: 'Competition',
            value: 'competition'
          },
          {
            text: 'Username',
            value: 'username'
          },
          {
            text: 'Comment',
            value: 'comment'
          },
          {
            text: 'Video',
            value: 'video'
          }, {
            text: 'Bookmarked',
            value: 'bookmarked'
          }
        ],
        US: [
          {
            text: 'Club',
            value: 'club'
          },
          {
            text: 'Team',
            value: 'team'
          },
          {
            text: 'Region',
            value: 'region'
          },
          {
            text: 'County',
            value: 'district'
          },
          {
            text: 'Competition',
            value: 'competition'
          },
          {
            text: 'Username',
            value: 'username'
          },
          {
            text: 'Comment',
            value: 'comment'
          },
          {
            text: 'Video',
            value: 'video'
          }, {
            text: 'Bookmarked',
            value: 'bookmarked'
          }
        ]
      },
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      csv: []
    }
  },
  methods: {
    removeVideo (index) {
      this.$emit('removeVideo', index)
    },
    exportCSV () {
      let array =
        typeof this.selectedVideos !== 'object'
          ? JSON.parse(this.selectedVideos)
          : this.selectedVideos
      let str = ''
      for (let i = 0; i < array.length; i++) {
        let line = ''
        for (let index in array[i]) {
          if (line !== '') line += ','
          line += array[i][index]
        }
        str += line + '\r\n'
      }
      this.csv = str
      let exportedFilename = 'cream.csv'
      let blob = new Blob([this.csv], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilename)
      } else {
        let link = document.createElement('a')
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', exportedFilename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    toggleBookmark (index) {
      this.$emit('toggleBookmark', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: 30px;
}

.cream-delete-button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CreamModeSelection.vue